import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { groupItemsByTypes } from '@/logic/main/utils';
import { SEARCH_RESULT_CATEGORY_ID } from '@/model/constants';
import { getLocale } from '@/utils';

export const setSearchResultsContent = async (context: LogicContext) => {
  const {
    searchPhrase,
    searchWords,
    searchItems,
    currentType,
  } = context.search;
  const deviceType = context.deviceInfo.deviceType;
  const locale = getLocale(config);
  const currency = context.user?.currency || config.default_currency;

  const groupedItems = groupItemsByTypes(searchItems);

  const searchResultCategory = {
    id: SEARCH_RESULT_CATEGORY_ID,
    title: `Search Results`,
    games: groupedItems[currentType],
  };

  const searchCategoryVisible = Boolean(searchItems.length > 0);

  const shouldSearchTagsBeHidden = !!context.search.searchPhrase;

  return {
    updates: [
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchNoResults.properties`,
          value: {
            visible: !searchCategoryVisible,
          },
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchResults.properties`,
          value: {
            visible: searchCategoryVisible,
          },
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchSuggestions.properties`,
          value: {
            visible: !shouldSearchTagsBeHidden,
          },
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchHistory.properties`,
          value: {
            visible: !shouldSearchTagsBeHidden,
            phrases: context.recentPhrases || [],
          },
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchHeader.properties`,
          value: {
            searchItems: groupedItems,
            searchedPhrase: searchPhrase,
          },
        },
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchResult.properties`,
          value: {
            searchedPhrase: searchPhrase,
            searchWords,
            category: searchResultCategory,
            locale,
            currency,
            deviceType,
          },
        },
      },
    ],
  };
};
